<template>
  <div>
    <Head :title="'商品搜尋' + title" />
    <div class="w-full my-5">
      <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_items" />
    </div>
    <!-- <div class="w-full my-5">
            包含
            <template v-for="keyword, index in $page.props.keywords">「{{ keyword }}」<template
                    v-if="index < $page.props.keywords.length - 1">、</template></template>
            的搜尋結果如下：
        </div> -->
    <div class="w-full">
      <div
        v-if="$page.props.result.total > 0"
        class="flex flex-wrap justify-center md:justify-start place-items-start"
      >
        <Product
          class="w-[160px] md:w-[255px]"
          v-for="product in $page.props.result.data"
          :key="product.type + '_' + product.id"
          :show-quantity-input="true"
          price-tag="vertical"
          :price="product.price"
          :cv="product.cv"
          :type="product.type"
          :id="product.id"
          :name="product.name"
          :slug="product.slug"
          :quantity="product.quantity"
          :includes="product.includes"
          :attributes="product.attributes"
          :settings="product.settings"
          :images="product.images"
        />
      </div>
      <div v-else class="text-fh-blue text-xl text-center my-48">
        沒有符合的搜尋結果
      </div>
    </div>
    <div class="w-full mt-10 flex justify-around">
      <!-- v-if="$page.props.result.total > $page.props.result.per_page" -->
      <Paginator :page-data="$page.props.result" />
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Breadcrumb from "primevue/breadcrumb";
import Product from "./Components/Product.vue";
import Paginator from "@/Shared/Paginator";

export default {
  components: { Breadcrumb, Product, Paginator },
  layout: Layout,
  data() {
    return {
      breadcrumb_home: {
        icon: "pi pi-home",
        command: () => {
          this.$inertia.visit("/");
        },
      },
    };
  },
  computed: {
    breadcrumb_items() {
      if (this.$page.props.keywords.length == 0)
        return [
          {
            icon: "pi pi-search",
            label: "商品搜尋",
            disabled: true,
          },
        ];

      let breadcrumb_label = "";

      _.forEach(this.$page.props.keywords, (keyword, index) => {
        breadcrumb_label += "「" + keyword + "」";
        if (index < this.$page.props.keywords.length - 1)
          breadcrumb_label += "或";
      });

      return [
        {
          icon: "pi pi-search",
          label: "包含" + breadcrumb_label + "的搜尋結果",
          disabled: true,
        },
      ];
    },
    title() {
      if (this.$page.props.keywords.length == 0) return "";

      let title = " - ";

      _.forEach(this.$page.props.keywords, (keyword, index) => {
        title += "「" + keyword + "」";
        if (index < this.$page.props.keywords.length - 1) title += "或";
      });

      return title;
    },
  },
  methods: {
    syncKeywords() {
      if (this.$page.props.keywords) {
        this.$parent.form.keywords = this.$page.props.keywords.join(" ");
      }
    },
  },
  mounted() {
    this.syncKeywords();

    fbq("track", "Search", {
      search_string: this.$parent.form.keywords,
    });
    console.log("fbq.track.Search", {
      search_string: this.$parent.form.keywords,
    });
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>